import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { CheckCircle2, Edit, Plus, Search, Trash2 } from "lucide-react";

// Habit library and assignment.
const HabitsTab = ({
  deleteHabit,
  filteredHabits,
  searchHabits,
  setEditingHabit,
  setHabitOpen,
  setNewHabit,
  setSearchHabits,
}) => {
  return (
    <div className="habits-view">
      <div className="view-header">
        <h1>Nawyki</h1>
        <div style={{display:'flex', gap:'8px', alignItems:'center'}}>
          <div style={{position:'relative'}}>
            <Search size={16} style={{position:'absolute',left:8,top:'50%',transform:'translateY(-50%)',color:'var(--text-secondary)'}} />
            <Input placeholder="Szukaj..." value={searchHabits} onChange={e => setSearchHabits(e.target.value)} style={{paddingLeft:32,width:200}} />
          </div>
          <Button onClick={() => { setEditingHabit(null); setNewHabit({ name: "", description: "" }); setHabitOpen(true); }}>
            <Plus size={18} /> Nowy nawyk
          </Button>
        </div>
      </div>

      {filteredHabits.length === 0 ? (
        <Card className="empty-state">
          <CardContent>
            <CheckCircle2 size={48} strokeWidth={1} />
            <h3>Brak nawyków</h3>
            <p>Dodaj nawyki dla swoich klientów</p>
          </CardContent>
        </Card>
      ) : (
        <div className="habits-grid">
          {filteredHabits.map(habit => (
            <Card key={habit.id} className="habit-card clickable-card" onClick={() => { setEditingHabit(habit); setNewHabit({ name: habit.name, description: habit.description || "" }); setHabitOpen(true); }}>
              <div className="habit-card-actions">
                <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); setEditingHabit(habit); setNewHabit({ name: habit.name, description: habit.description || "" }); setHabitOpen(true); }} data-testid={`edit-habit-${habit.id}`}>
                  <Edit size={14} />
                </Button>
                <Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); deleteHabit(habit.id); }} data-testid={`delete-habit-${habit.id}`}>
                  <Trash2 size={14} />
                </Button>
              </div>
              <CardContent>
                <CheckCircle2 size={24} />
                <div className="habit-details">
                  <h3>{habit.name}</h3>
                  {habit.description && <p>{habit.description}</p>}
                  <span className="habit-freq">{habit.frequency}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default HabitsTab;
